import { getRgObjectsOfType as t, RG_TYPE as r } from "@project-rouge/rg-core";
import { getArea as i } from "../index3.js";
import { isAmenityTechSpace as m } from "../../queries/index.js";
const a = (e) => i(t(e, r.TechnicalSpace).filter(m));
export {
  a as getAmenitiesArea
};
//# sourceMappingURL=index2.js.map
